import { SVGProps } from 'react'

export const WpsTableSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M14 3a1 1 0 00-1-1H9v5h5V3zM7 7H2V3a1 1 0 011-1h4v5zm0 2v5H3a1 1 0 01-1-1V9h5zm2 5V9h5v4a1 1 0 01-1 1H9zM2 0a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2H2z'
      fill='#2B84FF'
      fillRule='evenodd'
    />
  </svg>
)
